export function isGoalMeterActive(goalMeter, now = Date.now()) {
  return Boolean(goalMeter?.isActive && (!goalMeter.endDate || new Date(goalMeter.endDate).getTime() > now));
}
